<template>
  <div
    v-if="item"
    data-view="billing-account-form"
  >
    <Accordion
      title=""
      no-pointer
      no-header-border
      style="width: 100%; text-align: left;"
    >
      <template v-slot:content>
        <div
          v-if="showOptions"
          class="info-box vertical-margin"
        >
          {{ $t('billing_accounts_note') }}
          <span @click="onLearnMoreClick">{{ $t('learn_more') }}</span>
        </div>

        <v-radio-group
          v-if="showOptions"
          v-model="paymentMethod"
          class="payment-radio-group"
          inline
        >
          <magic-container>
            <span>
              <v-radio
                label="via a direct invoice"
                value="invoice"
                class="payment-method"
              />
            </span>
            <span>
              <v-radio
                label="via network"
                value="network"
                class="payment-method"
              />
            </span>
          </magic-container>
        </v-radio-group>

        <AddNewBillingForm
          v-if="paymentMethod === 'invoice'"
          :item="item"
          :is-on="isOn"
          :is-loading="isLoading"
          :on-cancel="onCancel"
          :on-confirm="onConfirm"
        />

        <AddNetworkForm
          v-else
          :item="item"
          :on-cancel="onCancel"
        />
      </template>
    </Accordion>
  </div>
</template>

<script>
  import Accordion from '../../panels/Accordion';
  import AddNewBillingForm from './AddNew';
  import AddNetworkForm from './Network';
  import { openUrlInNewWindow } from '../../../utils';

  export default {
    components: {
      Accordion,
      AddNewBillingForm,
      AddNetworkForm
    },
    props: {
      item: {
        type: Object,
        default: () => {}
      },
      isOn: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        required: true
      },
      onCancel: {
        type: Function,
        default: () => {}
      },
      onConfirm: {
        type: Function,
        default: () => {}
      },
    },
    data() {
      return {
        paymentMethod: 'invoice',
        helpLink: import.meta.env.VUE_APP_HELP_BILLING_SETTINGS_URL,
      };
    },
    computed: {
      showOptions() {
        return !this.item.payment_method || this.item.payment_method === 'network';
      }
    },
    watch: {
      isOn(newValue) {
        if (!newValue) {
          return this.clear();
        }

        if (this.item && this.item.payment_method && this.item.payment_method === 'network') {
          this.paymentMethod = 'network';
        }
      }
    },
    methods: {
      onLearnMoreClick() {
        openUrlInNewWindow(window.open(), this.helpLink);
      },
      clear() {
        this.paymentMethod = 'invoice';
      }
    }
  };
</script>

<style lang="scss">
  @use '../../../assets/styles/theme' as *;

  [data-view="billing-account-form"] {
    min-height: 100%;
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgb(var(--v-theme-surface));

    .info-box {
      margin-bottom: 24px;
      padding: 8px 16px;
      color: #424242;
      font-size: 12px;
      line-height: 16px;
      background: rgba(25, 118, 210, 0.07);
      border-radius: 2px;

      .v-theme--dark & {
        color: rgb(var(--v-theme-on-surface));
      }

      span {
        font-weight: 500;
        cursor: pointer;
      }
    }

    .vertical-margin {
      margin: 16px 16px 0;
      border-radius: 2px;
    }

    .payment-radio-group {
      height: 60px;
      margin-top: 24px;
      padding: 0 16px;

      .payment-method {
        padding: 11px 12px;
        border-radius: 4px;
        border: 1px solid #9E9E9E;
        width: 100%;
      }

      // Stacked on a phone, the two options are taller than the 60px row.
      @include phone {
        height: auto;
      }
    }
  }
</style>
